export const IMPORTACION_RESERVA_ESTADO = {
  COMPLETED: 'COMPLETED',
  PENDING: 'PENDING',
  PARTIALLY_COMPLETED: 'PARTIALLY_COMPLETED',
};
